<mat-toolbar color="primary">Deduplicate Patient Media</mat-toolbar>

<mat-dialog-content class="min-h-[200px]">
  @if (loading()) {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/60"
    >
      <mat-spinner diameter="40" />
      <p class="mt-4 text-sm">Scanning for duplicate media...</p>
    </div>
  } @else if (dedupGroups().length) {
    <p class="px-4 pt-4 text-sm text-black/60">
      Found {{ dedupGroups().length }} group(s) with duplicates
    </p>
    <mat-list>
      @for (group of dedupGroups(); track group.hash) {
        <mat-list-item>
          <mat-icon matListItemIcon>content_copy</mat-icon>
          <span matListItemTitle>Keep: {{ group.keepName }}</span>
          <span matListItemLine
            >Remove {{ group.duplicateCount }} duplicate{{
              group.duplicateCount === 1 ? '' : 's'
            }}: {{ group.duplicateNames.join(', ') }}</span
          >
        </mat-list-item>
      }
    </mat-list>
  } @else {
    <div
      class="flex flex-col items-center justify-center px-4 py-8 text-black/[0.38]"
    >
      <mat-icon
        fontSet="material-symbols-outlined"
        class="mb-4 !h-12 !w-12 !text-5xl"
        >folder_open</mat-icon
      >
      <p class="m-0 text-sm">No duplicate media found for this patient.</p>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close [disabled]="deleting()">Cancel</button>
  <button
    mat-flat-button
    color="warn"
    [disabled]="!dedupGroups().length || deleting()"
    (click)="deleteSelected()"
  >
    @if (deleting()) {
      <mat-spinner class="mr-2 inline-block" diameter="18" />
    }
    Delete Duplicates
  </button>
</mat-dialog-actions>
